module.exports = __webpack_public_path__ + "static/media/users-icon.ef1823e8.svg";